import React from 'react'
import { Link } from 'react-router-dom'
// import { Container } from 'semantic-ui-react'

export default function Footer() {
  return (
    <div id="footer-area">
      <div className="footer-block">
        <div className="a-logo">Clark Tree Services</div>
        <div style={{ fontSize: '.75em' }}>
          <div>Local Tree Expert.</div>
          <div>Licensed (#2037) and Insured.</div>
        </div>
      </div>

      <div className="footer-block">
        <div className="footer-nav-link">
          <Link to="/services">Our Services</Link>
        </div>
        <div className="footer-nav-link">
          <Link to="/about">About</Link>
        </div>
        <div className="footer-nav-link">
          <Link to="/why-choose-clark-tree-services">Why Us</Link>
        </div>
        <div className="footer-nav-link">
          <Link to="/contact">Contact</Link>
        </div>
      </div>

      <div className="footer-block">
        <div style={{ marginBottom: '15px' }}>
          Call us at <a href="tel:240-560-8733">240-560-TREE (8733)</a>
        </div>
        <div style={{ fontSize: '.75em' }}>
          <div>© 2026 Clark Tree Services.</div>
          <div>All rights reserved.</div>
          <div>
            <Link to="/privacy-policy">Privacy Policy</Link>
          </div>
        </div>
      </div>
    </div>
  )
}
